import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px 60px 60px 60px;
  border-radius: 50px;
  max-width: 900px;
  max-height: 85vh;
  width: 60%;

  @media (max-width: 1200px) {
    width: 90%;
    margin-top: 100px;
    padding: 12px;
    overflow-y: auto;
    border-radius: 20px;
    max-height: calc(85vh - 100px);
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 800px) {
    flex-direction: column;
  }
}`;

export const ModalTitle = styled.h1`
  font-size: 2.5rem;

  @media (max-width: 1200px) {
    font-size: 1.5rem;
  }
}`;

export const StyledLogo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 24px;
  gap: 10px;
  border-radius: 8px;
  background: ${customPalette.accent.main};

  @media (max-width: 1500px) {
    display: none;
  }
`;

export const LogoText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AppTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${customPalette.accent.white};
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${customPalette.accent.white};
`;

export const ModalBody = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 50vh;
  overflow-y: auto;

  @media (max-width: 1200px) {
    max-height: calc(50vh - 100px);
  }
`;

export const Paragraph = styled.p`
  font-size: 20px;
  line-height: 1.5;

  @media (max-width: 1200px) {
    font-size: 16px;
  }
`;

export const ModalFooter = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
`;

export const BPItem = styled.li`
  padding: 12px;
  margin: 8px 0;
  border-radius: 8px;
  background-color: ${customPalette.accent.main};
  color: ${customPalette.accent.white};
  display: flex;
  align-items: center;

  @media (max-width: 1200px) {
    padding-left: 8px;
    width: 100%;
    max-width: 250px;
    margin: 0;
  }
`;

export const IconWrapper = styled.div`
  flex: 0 0 20%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1200px) {
    justify-content: flex-start;
    margin-right: 8px;
  }
`;

export const BPDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: ${customPalette.accent.white};
  padding-left: 12px;
  flex: 1;

  .bp-number {
    font-weight: bold;
  }

  .bp-name {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 100px;
  }

  @media (max-width: 1200px) {
    padding-left: 8px;
  }
`;
